
import storeInfo from '../store'
import { Estimate } from '../types'
import { EstimatesByCategoryType } from './types'

export const getEstimatesByStage = (stage: string) => (): Estimate | undefined => {
  const { estimatesByCategory } = storeInfo.store.getState()
  return estimatesByCategory[stage as keyof EstimatesByCategoryType]
}
